<template>
<div class="shortmessageadd"  >
    <div class="top"> 
           <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
            <el-button type="primary" size="medium" @click="inserts()">提交审核</el-button>
    </div>
    <div class="subject" :style="`height: ${windowHeight-180}px;`">
      <div class="body">
       <div class="title">您将为<span>{{schoolName}}</span>进行短信充值：</div>
       <div class="button">
           <span :class="{'color' : count==20000}" @click="numfun(20000)">20000条</span>
           <span :class="{'color' : count==10000}" @click="numfun(10000)">10000条</span>
           <span :class="{'color' : count==5000}" @click="numfun(5000)">5000条</span>
           <span :class="{'color' : count==2000}" @click="numfun(2000)">2000条</span>          
       </div>
       <div class="title">自定义: <el-input-number v-model="num" :min="1"  :precision="0" :step="1" :max="1000000" ></el-input-number></el-input-number></div>
       <div class="title">请填写充值原因：</div>
        <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 10}" v-model.trim="remark" :maxlength="500"
                placeholder="请填写充值原因"></el-input>
      </div>
    </div>    
</div> 
</template>
<script>
import {insert} from "@/api/shortmessage";
import mixin from "@/mixins/windowResize";
export default {
  data() {
    return {
     schoolId:this.$route.query.schoolId, 
     schoolName: this.$route.query.schoolName,
     remark:"",
     count:20000,
     num:undefined
    };
  },
  mixins: [mixin],
  created() {
  },
  methods: {  
      numfun(num){
       this.count=num;
      },    
     inserts(){
         if(!this.remark){
               this.$message({type: 'error', message:'请填写充值原因!'});
             return;
         }
               this.$confirm('是否提交审核?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let obj={
                        count:this.num?this.num:this.count,//	充值数量	number	@mock=1000
                        money:(this.num?this.num:this.count)/10,//	原价(元)	string	@mock=100
                        realMoney:0,//	支付金额(元)	string	@mock=99.9
                        remark:this.remark,//	备注	string	@mock=充值备注
                        type:1,//	//充值方式 1:平台赠送 2:在线充值 3:对公汇款	number	@mock=1
                        schoolId:this.schoolId
                    }
                    insert(obj).then(res => {
                        this.$message({
                            type: 'success',
                            message: '提交审核成功!'
                        });
                        this.$router.go(-1);
                    }).catch();

                }).catch(() => {
                });
            },    
  }
};
</script>
<style lang="scss" scoped>
.shortmessageadd {
   padding: 12px;
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
    overflow: hidden;
  }
  .subject {
    padding-top: 10px;
    overflow: auto;
    .body{
      width: 810px;
      margin: 0 auto;
      .title{
           font-size: 16px;
            color: #606266;
            line-height: 40px;
            span{
                margin: 0 5px;
                color:#409EFF;
            }
      }  
      .button{
          overflow: hidden;
          span{
              float: left;
              width: 120px;
              text-align: center;
              font-size: 16px;
              line-height: 48px;
              border-radius: 5px;
              margin: 10px ;
              color: #409eff;
              background: #fff;
              border: 1px solid #b3d8ff;
              cursor:pointer;
          }
          .color{
              color:#fff;
              background:#409eff; 
              border-color: #409eff;
          }
      }
    }    
  }   
}
</style>


// WEBPACK FOOTER //
// src/views/shortmessage/shortmessageadd.vue